// extracted by mini-css-extract-plugin
module.exports = {"root":"styles_root__1jPqO","clinicsSelect":"styles_clinicsSelect__2hySg"};